import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { User, UserAdmin } from '../../administration/user/user';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-change-user-email-account-dialog',
    templateUrl: './change-user-email-account-dialog.component.html',
    styleUrls: ['./change-user-email-account-dialog.component.scss'],
})
export class ChangeUserEmailAccountDialogComponent implements OnInit {
    user: User;
    userAdmin = new UserAdmin();
    emailKopie = false;
    emailRechnungKopie = false;

    constructor(
        public dialogRef: MatDialogRef<ChangeUserEmailAccountDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneTableService,
        private notificationService: MessageService,
    ) {
        this.user = data.user;
    }

    ngOnInit() {
        this.loadUserAdmin();
    }

    loadUserAdmin() {
        this.api
            .getOne(this.apiBaseUrl + 'benutzer_admin/read_one.php', 'benutzer_id', this.user.benutzer_id.toString())
            .subscribe(response => {
                this.userAdmin = response;
                this.emailKopie = this.userAdmin.email_kopie === 1;
                this.emailRechnungKopie = this.userAdmin.email_rechnung_kopie === 1;
            });
    }

    cancel() {
        this.dialogRef.close(null);
    }

    save() {
        if (!this.userAdmin.benutzer_id) {
            this.userAdmin.benutzer_id = this.user.benutzer_id;
        }
        this.userAdmin.email_kopie = this.emailKopie ? 1 : 0;
        this.userAdmin.email_rechnung_kopie = this.emailRechnungKopie ? 1 : 0;
        this.api.updateEntity(this.apiBaseUrl + 'benutzer_admin/update.php', this.userAdmin).subscribe(
            () => {
                this.notificationService.infoMessage('Die E-Mail Account Daten wurden erfolgreich gespeichert!');
                this.dialogRef.close(true);
            },
            error => {
                this.notificationService.errorMessage(
                    'Die E-Mail Account Daten konnten nicht gepeichert werden! ',
                    error,
                );
                this.dialogRef.close(false);
            },
        );
    }
}
